<!--
 * @Author: your name
 * @Date: 2021-04-22 11:29:07
 * @LastEditTime: 2021-05-14 10:36:25
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /youhuaguo-ui/src/views/officialSeal/index.vue
-->
<template>
  <div class="list-panel">
    <div class="main-container">
      <div class="tab-con">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item index="stay">待审批</el-menu-item>
          <el-menu-item index="has">已审批</el-menu-item>
        </el-menu>
      </div>
      <div class="content-wrap">
        <list v-if="listShow" :brandType="activeIndex"></list>
      </div>
    </div>
  </div>
</template>

<script>
import list from './list'
export default {
  data() {
    return {
      activeIndex: "stay",
      listShow:true
    };
  },
  components: {
    list
  },
  methods: {
    handleSelect(key, keyPath) {
      this.listShow = false
      setTimeout(()=>{
        this.listShow = true
      },50)
      this.activeIndex = key;
    },
  },
}
</script>